
import type {PropType} from 'vue';
import {defineComponent, ref} from 'vue';
// import usei18n from '@/composables/usei18n';
import usei18n from '../../util/composable/usei18n';
// import Icon from '@/components/Icon/Icon.vue';
import Icon from '../Icon/Icon.vue';
import type {SubMenuItem, TopMenuItem} from './types';
// import DropdownMenu from '@/components/DropdownMenu/DropdownMenu.vue';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';

export default defineComponent({
  name: 'OxdNavigationMore',

  components: {
    'oxd-icon': Icon,
    'oxd-dropdown-menu': DropdownMenu,
  },

  props: {
    menuItems: {
      type: Array as PropType<TopMenuItem[]>,
      required: false,
      default: () => [],
    },
  },

  setup() {
    const expandedIndex = ref(-1);
    const onClickMenu = (
      $event: MouseEvent,
      item: TopMenuItem | SubMenuItem,
      index: number,
    ) => {
      if (
        !(item as TopMenuItem).children ||
        (item as TopMenuItem).children.length === 0
      ) {
        window.location.replace(item.url);
      } else {
        $event.preventDefault();
        $event.stopPropagation();
        expandedIndex.value = expandedIndex.value === index ? -1 : index;
      }
    };

    const onClose = () => {
      expandedIndex.value = -1;
    };

    return {
      onClose,
      onClickMenu,
      expandedIndex,
      ...usei18n(),
    };
  },
});
